import { EndpointPathNames } from "@/shared/config/endpoint-path";
import { AuthenticationType } from "@/shared/config/globals"
import { useSignUp } from "@/features/user/hooks/use-sign-up";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { MailAddressForm } from "@/shared/components/text-box/mail-address-form";
import { BaseSnackBarContext } from "@/shared/components/snack-bar/base-snack-bar-context";
import React, { useContext, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { AgreeTermsCheckbox } from "@/features/legal/components/agree-terms-check-box";
import { useAgreeTerms } from "@/features/legal/hooks/use-agree-terms";
import { LoginHeader } from "@/shared/components/header/login-header";
import { Footer } from "@/shared/components/footer/footer";

export const SignUp = () => {
  const navigate = useNavigate();

  const location = useLocation();
  const snackBarMessage = (location.state as string) ?? "";
  const { openBaseSnackBar } = useContext(BaseSnackBarContext);
  useEffect(() => {
    if (snackBarMessage !== "") {
      openBaseSnackBar(snackBarMessage);
    }
  }, [snackBarMessage]);

  const {
    email,
    emailError,
    isActiveSendMailButton,
    setIsActiveSendMailButton,
    onChangeMailAddress,
    onClickSendMail,
  } = useSignUp();

  const {
    onTapAgreement,
    checkedAgreement
  } = useAgreeTerms();

  // ログイン画面遷移
  const pushLoginView = () => {
    navigate(EndpointPathNames.LOGIN);
  };

  // メールアドレス入力情報が更新された場合のコールバック関数定義
  const changeSendMailButtonState = () => {
    setIsActiveSendMailButton(email !== "" && checkedAgreement);
  };

  useEffect(() => {
    changeSendMailButtonState();
  }, [email, checkedAgreement]);


  // メールアドレスフォームに付与するID
  const mailAddressFormId = "signUpMail";
  // キャンセルボタンに付与するID
  const cancelButtonId = "cancel_button_id";
  // メール送信ボタンに付与するID
  const sendMailButtonId = "btnSignUp";

  return (
    <>
      <LoginHeader content="新しいアカウントを作成" />
      <main>
        <section id="signUp">
          <nav className="step">
            <ol>
              <li className="active">仮登録メールを送信</li>
              <li>パスワードの設定</li>
              <li>ユーザー名の設定</li>
              <li>登録完了</li>
            </ol>
          </nav>
          <p>ご入力いただいたメールアドレスへ仮登録メールを送信します</p>
          <ul className="form">
            <li>
              <MailAddressForm
                className="signUpMail"
                onChange={onChangeMailAddress}
                errorMessage={emailError}
                id={mailAddressFormId}
                title="メールアドレス"
                initialValue={email}
              />
            </li>
            <li>
              <AgreeTermsCheckbox
                checked={checkedAgreement}
                onTapAgreement={onTapAgreement}
              />
            </li>
          </ul>
          <nav className="btns">
            <span style={{ marginRight: "0.3rem"}}>
              <BaseRoundButton
                className="btn-base"
                id={cancelButtonId}
                buttonText="キャンセル"
                onClick={pushLoginView}
                isActive={true}
              />
            </span>
            <BaseRoundButton
              className="nav-main"
              id={sendMailButtonId}
              buttonText="メールを送信"
              onClick={() => onClickSendMail(AuthenticationType.SignUpAuth)}
              isActive={isActiveSendMailButton}
            />
          </nav>
        </section>
      </main>
      <Footer />
    </>
  );
};
